/**
 * Methods related to Browser Cookies
*/
import Cookie from "js-cookie";

export default {
  /**
   * Gets the Moodle session Cookie from Browser Cookies
   */
  getCookie() {
    let token = Cookie.get("MoodleSession");

    if (token) {
      return new Promise(resolve => {
        resolve(token);
      });
    }

    return false;
  },

  /**
   * Sets a cookie in the browser
   */
  setCookie(name, value){
    Cookie.set(name, value);
  }
};
